import { isNotNilOrEmpty } from '@pcty/utils';
/**
 * Formats a value as a percentage
 * @param {number} value The value to format
 * @returns {string} The formatted string
 */
export var percentageFormatter = function (value) { return (isNotNilOrEmpty(value) ? "".concat(value, "%") : ''); };
